import styled from "styled-components";

export const ContainerEditarSolicitacao = styled.div`
  max-width: 100%;
  // border: 2px solid ${({ tema }) => tema || "#848484"};
  border-radius: 4px;
  margin-top: -10px;
  margin-bottom: 24px;
`;

export const HeaderEditarSolicitacao = styled.div`
  max-width: 100%;
  background-color: #ffffff;
  // padding-left: 16px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  // border-bottom: 2px solid ${(props) => props.alertColor || "#848484"};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  span {
    color: ${(props) => props.alertColor || "#848484"};
    font-size: 14px;
    font-weight: bold;
  }
`;

export const IconContainer = styled.div`
  width: 35px;
  height: 30px;
  background-color: ${(props) => props.alertColor || "#848484"};
`;

export const BodyEditarSolicitacao = styled.div`
  max-width: 100%;
  min-height: 50px;
  border: 1px solid #d1d1d1;
  filter: drop-shadow(0px 1px 3px rgba(77, 77, 77, 0.1))
    drop-shadow(0px 1px 2px rgba(77, 77, 77, 0.06));
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 60px;
`;

export const Descricao = styled.textarea.attrs((props) => ({
  placeholder: props.placeholder,
  type: "text",
  wrap: "soft",
  maxlength: 2000,
}))`
  max-width: 100%;
  width: calc(100% - 36px);
  word-wrap: break-word;
  resize: none;
  min-height: 100px;
  padding: 16px;
  color: #4d4d4d;
  border: 2px solid #848484;
  border-radius: 4px;
`;

export const AdicionarNovoReparo = styled.button.attrs((props) => ({
  disabled: props.disabled,
}))`
  max-width: 100%;
  width: 100%;
  border: 1px dashed #b1b3b3;
  border-radius: 8px;
  background-color: transparent;
  color: #ffffff;
  font-weight: bold;
  transition: 0.3s;
  cursor: pointer;
  font-size: 22px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #848484;
  .plusIcon {
    background-color: #bfd7ff;
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-bottom: 4px;
    color: #1d3054;
    font-size: 32px;
  }

  .title {
    color: #1d3054;
    line-height: 30px;
  }

  .subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    color: #4d4d4d;
  }

  &:hover {
    box-shadow: 0px 0px 8px ${(props) => props.tema};
  }

  &:disabled {
    background-color: transparent;
    cursor: auto;
    color: red;
    &:hover {
      box-shadow: none;
    }
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
